import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import Button from "../../ui/Button/Button";
import Form from "../../ui/Form/Form";
import Input from "../../ui/Input/Input";
import { offerFormSchema } from "../../utils/formShemas";

export default function OfferForm({ offer, onSubmit, title, submitText = 'Click', disabled = false }) {

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(offerFormSchema),
        defaultValues: {
            display_line: offer?.display_line || '',
            team: offer?.team || '',
            cc: offer?.cc || '',
            language: offer?.language || '',
            model: offer?.model || '',
            price: offer?.price || '',
            cr: offer?.cr || '',
            funnels: offer?.funnels?.join(', ') || '',
            sources: offer?.sources?.join(', ') || '',
        },
    });

    const formSubmit = async (formData) => {
        const submitObj = {
            ...formData,
            funnels: formData?.funnels?.replaceAll(', ', ',').split(','),
            sources: formData?.sources?.replaceAll(', ', ',').split(','),
        }
        onSubmit(submitObj);
    }

    return (
        <Form onSubmit={handleSubmit(formSubmit)} title={title} >
            <Input
                placeholder="display_line"
                {...register('display_line')}
                error={errors.display_line?.message}
            />
            <Input
                placeholder="team"
                {...register('team')}
                error={errors.team?.message}
            />
            <Input
                placeholder="cc"
                {...register('cc')}
                error={errors.cc?.message}
            />
            <Input
                placeholder="language"
                {...register('language')}
                error={errors.language?.message}
            />
            <Input
                placeholder="model"
                {...register('model')}
                error={errors.model?.message}
            />
            <Input
                placeholder="price"
                {...register('price')}
                error={errors.price?.message}
            />
            <Input
                placeholder="cr"
                {...register('cr')}
                error={errors.cr?.message}
            />
            <Input
                placeholder="funnels"
                {...register('funnels')}
                error={errors.funnels?.message}
            />
            <Input
                placeholder="sources"
                {...register('sources')}
                error={errors.sources?.message}
            />

            <Button disabled={disabled} type="submit">
                {submitText}
            </Button>
        </Form>
    )
}
